
import banner from '@/assets/jfcj/banner6.png'
import zhizhen from '@/assets/jfcj/zhuanpan-zhizhen2.png'
import zhizhenGray from '@/assets/jfcj/zhuanpan-zhizhen2-gray.png'
import openbg from '@/assets/jifenhuangou/lottery/popup-bg.png'
import config from '@/config'
import { getintegral, operateCreditlist } from '@/api/user.js'
import { award } from '@/api/lottery'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'

import {
addCreditParty,
relation,
view,
addPartyCount,
cutCreditPartyNum,
cutCreditParty
} from '@/api/jfhl.js'
import { stampGet, stampPay } from '@/api/jianianhua.js'
import { getUserItem } from '@/api/lottery.js'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XButton
},
data () {
return {
baseUrl: config.baseUrl,
lottimg: '', // 抽奖图
banner: banner, // banner
ruleInfo: '', // 规则
lotNum: 5, // 抽奖次数

checkstyle: false,
zhizhen: zhizhen,
times: '', // 答题次数
lotid: 0,
showOpen: false,
openbg: openbg,
prize: '',
start_rotating_degree: 0, // 初始旋转角度
rotate_angle: 0, // 将要旋转的角度
rotate_transition: 'transform 6s ease-in-out', // 初始化选中的过度属性控制
rotate_transition_pointer: 'transform 10s ease-in-out', // 初始化指针过度属性控制
click_flag: true, // 是否可以旋转抽奖
partyid: this.$route.params.partyid,

prizelist: [], // 奖品列表
angle: '', // 转动角度
tablist: [
{
title: '活动规则'
},
{
title: '我的奖品'
}
],
selected: 0,
startTime: '',
endTime: '',
integral: '',
owner_type: config.owner_type,
isclick: false,
prizetype: false,
num: '',
rulecode: ''
}
},
created () {
this.addcount() 

this.getview() 
this.getintegralTotal() 
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
},
top () {
return -this.activeIndex * 30 + 'px'
}
},
methods: {

addcount () {
addPartyCount({
partyid: this.partyid,
accoutid: this.accountid,
credittype: 1
}).then(res => { })
},













addJiFen (credit) {
addCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
type: 1
}).then(res => { })
},

addStamp (stampnum) {
stampGet({
accountId: this.accountid,
num: stampnum,
type: 6,
ruleCode: 'JFCJ002'
}).then(res => { })
},

getActiveNum () {
cutCreditPartyNum({
accoutid: this.accountid
}).then(res => {
if (this.lotNum - parseInt(res.obj.num) <= 0) {
this.isclick = true
this.zhizhen = zhizhenGray
this.$vux.alert.show({
content: '您的抽奖次数已经用完'
})
}
})
},

getview () {
view({
id: this.partyid
}).then(res => {
this.ruleInfo = res.obj.hddesc
this.lotid = res.obj.lotid
this.startTime = res.obj.signstartdate.replace(/-/g, '/')
this.endTime = res.obj.signenddate.replace(/-/g, '/')
this.prizetype = res.obj.prizetype
this.num = res.obj.num
this.rulecode = res.obj.rulecode
this.isCurrentTime(this.startTime, this.endTime)
this.getWinning()
})
},

isCurrentTime (beginTime, endTime) {
var currentTime = new Date()
beginTime = new Date(beginTime)
endTime = new Date(endTime)
if (currentTime < beginTime) {
this.$vux.alert.show({
content: '抽奖活动还未开始'
})
this.isclick = true
this.zhizhen = zhizhenGray
return false
}
if (currentTime >= endTime) {
this.$vux.alert.show({
content: '抽奖活动已结束'
})
this.isclick = true
this.zhizhen = zhizhenGray
return false
}
this.isclick = false
this.getActiveNum()
},

cutCredit (credit, fn) {
if (this.prizetype == '1') {
cutCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
partytype: 'party'
}).then(() => {
if (fn) fn()
})
} else if (this.prizetype == '2') {
stampPay({
accountId: this.accountid,
num: credit,
type: 6,
ruleCode: 'JFCJ001'
}).then(() => {
if (fn) fn()
})
}
},

getintegralTotal () {
getintegral({
accountid: this.accountid,
owner_type: this.owner_type,
userid: this.userid
}).then(res => {
this.integral = res.returnValue.allnow
})
},

go () {
if (!this.isclick) {
if (!this.checkstyle) {
this.$vux.alert.show({
content: '请点击勾选下方栏位，确认相关规则后再参与活动'
})
return false
}
stampGet({
num: this.num,
ruleCode: this.rulecode,
accountId: this.accountid
})
this.isaward()
this.isclick = true
}
},
ontab (index) {
this.selected = index
},

isaward () {
if (this.integral >= 10) {
award({
lotid: this.lotid,
openid: this.accountid,
lotteryNum: 5
}).then(data => {
if (data.success) {
if (data.obj.isaward === 2) {
this.zhizhen = zhizhenGray
this.$vux.alert.show({
content: '已抽过奖'
})
} else {
this.angle = data.obj.angle
this.prize = data.obj.item
this.cutCredit(10, () => {
if (data.obj.item !== '谢谢参与') {
if (data.obj.prizetype == 3) {
this.addJiFen(data.obj.item.replace(/[^0-9]/gi, ''))
} else if (data.obj.prizetype == 4) {
this.addStamp(data.obj.item.replace(/[^0-9]/gi, ''))
}
}
})

this.rotating(parseInt(this.angle))






}
}
})
} else {
this.zhizhen = zhizhenGray
this.isclick = true
this.$vux.alert.show({
content: '积分不足'
})
}
},

rotating (degree) {

var type = 0 
var during_time = 5 
var rand_circle = 5 
if (type === 0) {

var rotate_angle =
this.start_rotating_degree +
(360 - (this.start_rotating_degree % 360)) +
rand_circle * 360 +
degree 
this.start_rotating_degree = rotate_angle
this.rotate_angle = 'rotate(' + rotate_angle + 'deg)'

setTimeout(() => {
this.winning()
}, during_time * 1000)
}
},

getWinning () {
getUserItem({
openid: this.accountid,
lotid: this.lotid
}).then(res => {
this.prizelist = res.obj.items
})
},

winning () {
setTimeout(() => {
this.showOpen = true
}, 2000)
},

close () {
this.showOpen = false
this.isclick = false
this.getWinning()
this.getintegralTotal()
this.getActiveNum()
}
}
}
